/* Elyne — thème Shopify : interactions + vrai panier (/cart/add.js) */
(function () {
  var cfg = window.Elyne || {};

  /* ---- Menu mobile ---- */
  var burger = document.querySelector('[data-burger]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () { mobileNav.classList.toggle('open'); });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileNav.classList.remove('open'); });
    });
  }

  /* ---- Toast ---- */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }

  /* ---- Avis vidéo : clic = lightbox plein écran avec le son ---- */
  var vlb = document.querySelector('[data-vlb]');
  var vlbVideo = document.querySelector('[data-vlb-video]');
  function openVlb(src) {
    if (!vlb || !vlbVideo || !src) return;
    vlbVideo.src = src;
    vlbVideo.muted = false;
    vlbVideo.currentTime = 0;
    vlb.hidden = false;
    vlbVideo.play().catch(function () {});
  }
  function closeVlb() {
    if (!vlb) return;
    vlbVideo.pause();
    vlbVideo.removeAttribute('src');
    vlbVideo.load();
    vlb.hidden = true;
  }
  document.querySelectorAll('[data-video]').forEach(function (card) {
    card.addEventListener('click', function () {
      var v = card.querySelector('video');
      var src = v ? v.getAttribute('src') : null;
      if (src) openVlb(src);
    });
  });
  if (vlb) {
    vlb.addEventListener('click', function (e) { if (e.target === vlb) closeVlb(); });
    var vlbClose = document.querySelector('[data-vlb-close]');
    if (vlbClose) vlbClose.addEventListener('click', closeVlb);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVlb(); });
  }

  /* ---- FAQ accordéon ---- */
  document.querySelectorAll('[data-faq] .faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    q.addEventListener('click', function () {
      var open = item.classList.contains('open');
      document.querySelectorAll('[data-faq] .faq-item').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!open) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---- Bloc d'achat : offres = variantes Shopify ---- */
  var variants = document.querySelectorAll('[data-variant]');
  var current = null;
  var subToggle = document.querySelector('[data-sub]');
  var priceDisplay = document.querySelector('[data-price-display]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var addbarPrice = document.querySelector('[data-addbar-price]');
  var cureLabel = document.querySelector('[data-cure-label]');
  var addButtons = document.querySelectorAll('[data-add-main]');

  function useSub() {
    return !!(subToggle && subToggle.checked && current && current.dataset.sellingPlan);
  }
  function displayPrice() {
    if (!current) return;
    var shown = useSub() ? current.dataset.subPrice : current.dataset.price;
    [priceDisplay, stickyPrice, addbarPrice].forEach(function (el) { if (el) el.textContent = shown; });
    var soldOut = current.dataset.available !== 'true';
    addButtons.forEach(function (b) {
      b.disabled = soldOut;
      var label = b.querySelector('[data-add-label]') || b;
      if (!b.classList.contains('is-loading')) label.textContent = soldOut ? 'Épuisé' : 'Ajouter au panier';
    });
    if (subToggle) {
      var wrap = subToggle.closest('.pdp-sub');
      if (wrap) wrap.style.display = current.dataset.sellingPlan ? '' : 'none';
    }
  }
  function selectVariant(el) {
    variants.forEach(function (v) { v.classList.remove('active'); });
    el.classList.add('active');
    current = el;
    if (cureLabel) cureLabel.textContent = el.dataset.plan;
    displayPrice();
  }
  variants.forEach(function (v) { v.addEventListener('click', function () { selectVariant(v); }); });
  if (subToggle) subToggle.addEventListener('change', displayPrice);
  var activeVar = document.querySelector('[data-variant].active') || variants[0];
  if (activeVar) selectVariant(activeVar);

  /* ---- Ajout au panier réel ---- */
  function setLoading(on) {
    addButtons.forEach(function (b) {
      b.classList.toggle('is-loading', on);
      b.disabled = on;
      var label = b.querySelector('[data-add-label]') || b;
      if (on) label.textContent = 'Ajout…';
    });
    if (!on) displayPrice();
  }
  function refreshCount() {
    fetch((cfg.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
      })
      .catch(function () {});
  }
  function addToCart() {
    if (!current) return;
    var item = { id: Number(current.dataset.variantId), quantity: 1 };
    if (useSub()) item.selling_plan = Number(current.dataset.sellingPlan);
    setLoading(true);
    fetch(cfg.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Erreur');
        if (cfg.afterAdd === 'checkout') {
          window.location.href = '/checkout';
        } else if (cfg.afterAdd === 'cart') {
          window.location.href = cfg.cartUrl || '/cart';
        } else {
          setLoading(false);
          refreshCount();
          showToast('Ajouté : ' + current.dataset.plan + ' 🌙');
        }
      })
      .catch(function (err) {
        setLoading(false);
        showToast(err.message || 'Impossible d\'ajouter au panier');
      });
  }
  addButtons.forEach(function (btn) { btn.addEventListener('click', addToCart); });

  /* ---- Compte à rebours promo (se termine à minuit) ---- */
  var promoClock = document.querySelector('[data-clock]');
  if (promoClock) {
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tickPromo = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      promoClock.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    };
    tickPromo();
    setInterval(tickPromo, 1000);
  }

  /* ---- Barre d'achat sticky ---- */
  var stickyCart = document.querySelector('.sticky-cart');
  var mainAddBar = document.querySelector('.pdp-addbar');
  if (stickyCart && mainAddBar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      stickyCart.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(mainAddBar);
  }

  /* ---- Galerie produit : miniatures ---- */
  var mainImg = document.querySelector('[data-main-img]');
  var mainVid = document.querySelector('[data-main-video]');
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var vid = t.getAttribute('data-thumb-video');
      var src = t.getAttribute('data-thumb-src');
      if (vid && mainVid) {
        mainVid.setAttribute('src', vid);
        mainVid.style.display = 'block';
        if (mainImg) mainImg.style.display = 'none';
        mainVid.play().catch(function () {});
      } else if (src && mainImg) {
        mainImg.setAttribute('src', src);
        mainImg.style.display = 'block';
        if (mainVid) { mainVid.pause(); mainVid.style.display = 'none'; }
      }
    });
  });

  /* ---- Carrousel vidéos clientes : défilement auto + swipe (mobile compris) ---- */
  var proofBox = document.querySelector('.proof-carousel');
  var proofTrack = document.querySelector('[data-proof-track]');
  if (proofBox && proofTrack) {
    var pos = 0, paused = false, resumeT = null, last = null;
    var speed = window.matchMedia('(max-width:560px)').matches ? 28 : 40; /* px par seconde */
    var pause = function () { paused = true; clearTimeout(resumeT); };
    var resumeLater = function (ms) {
      clearTimeout(resumeT);
      resumeT = setTimeout(function () { pos = proofBox.scrollLeft; paused = false; }, ms);
    };
    proofBox.addEventListener('touchstart', pause, { passive: true });
    proofBox.addEventListener('touchend', function () { resumeLater(2500); }, { passive: true });
    if (window.matchMedia('(hover:hover)').matches) {
      proofBox.addEventListener('mouseenter', pause);
      proofBox.addEventListener('mouseleave', function () { resumeLater(300); });
    }
    var step = function (t) {
      if (last !== null && !paused && !document.hidden) {
        var half = proofTrack.scrollWidth / 2;
        pos += speed * Math.min(t - last, 64) / 1000;
        if (pos >= half) pos -= half;
        proofBox.scrollLeft = pos;
      } else if (paused) {
        var h = proofTrack.scrollWidth / 2;
        if (proofBox.scrollLeft >= h) { proofBox.scrollLeft -= h; }
      }
      last = t;
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);

    /* Ne lire que les vidéos visibles : iPhone bloque au-delà de quelques vidéos simultanées */
    var vids = proofTrack.querySelectorAll('video');
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { v.muted = true; v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { vio.observe(v); });
    } else {
      vids.forEach(function (v) { v.play().catch(function () {}); });
    }
  }
})();
